import * as actions from "./actions";

let todayDate = new Date();

let initialState = {
  fetching: false,
  fetched: false,
  error: null,
  table: {
    currentFilter: null,
    pagination: { page: 1, take: 20 },
    timespan: {
      from: new Date(
        todayDate.getFullYear(),
        todayDate.getMonth(),
        todayDate.getDate(),
        12,
      ),
      to: new Date(
        todayDate.getFullYear(),
        todayDate.getMonth(),
        todayDate.getDate() + 1,
        12,
      ),
    },
  },
  data: null,
};

const transactions = (state = initialState, action) => {
  switch (action.type) {
    // GET TRANSACTIONS
    case actions.TRANSACTIONS_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        fetching: true,
        error: null,
      });
    case actions.TRANSACTIONS_LIST_GET_SUCCESS:
      return Object.assign({}, state, {
        fetching: false,
        fetched: true,
        data: action.response,
      });
    case actions.TRANSACTIONS_LIST_GET_ERROR:
      return Object.assign({}, state, {
        fetching: false,
        error: action.error,
      });
    case actions.TRANSACTION_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          pagination: Object.assign({}, state.table.pagination, {
            page: action.page,
          }),
        }),
      });
    case actions.TRANSACTION_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          currentFilter: Object.assign({}, state.table.currentFilter, {
            ...action.filter,
          }),
        }),
      });
    case actions.TRANSACTION_FILTER_DATE_CHANGED: {
      let date =
        action.key === "to" ? { to: action.value } : { from: action.value };
      return Object.assign({}, state, {
        table: Object.assign({}, state.table, {
          timespan: Object.assign({}, state.table.timespan, {
            ...state.table.timespan,
            ...date,
          }),
        }),
      });
    }
    default:
      return state;
  }
};

export default transactions;
